module.exports = __webpack_public_path__ + "static/media/sign-up-bg.de29d0e9.jpg";